import produce from 'immer';

const INITIAL_STATE = {
  token: null,
  signed: false,
  loading: false,
};

export default function auth(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@auth/LOGIN_SUCCESS': {
        const { token } = action.payload;
        draft.token = token;
        draft.signed = true;
        draft.loading = false;
        break;
      }
      case '@auth/LOGIN_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@auth/LOGIN_FAIL': {
        draft.loading = false;
        break;
      }
      case '@auth/LOGOUT_APP': {
        draft.token = null;
        draft.signed = null;
        break;
      }
      default:
    }
  });
}
